export const environment = {
  production: false,
  apiDomain: '.aladdinportal.com',
  title: 'Aladdin Companies',
  environmentName: 'dev',
  displayEnvironmentWarning: true,
  appVersion: "261104.59", // DO NOT EDIT!  This will be automatically updated in the build pipeline to trigger wiping of the user's local storage on each release

  // API URLs
  dotNetApiUrl: 'https://api-dev.aladdinportal.com/api',
  reportingServiceUrl: 'https://reporting-dev.aladdinportal.com',

  // SignalR URLs
  signalRUrl: 'https://api-dev.aladdinportal.com/messageHub',
  userPageTrackingUrl: 'https://api-dev.aladdinportal.com/userPageTrackingHub',
  sideNavHubUrl: 'https://api-dev.aladdinportal.com/sideNavHub',

  // Telerik URLs
  telerikReportingUrl: 'https://api-dev.aladdinportal.com/api/telerik/reports',
  telerikEmbeddedUrl: 'https://reporting-dev.aladdinportal.com/reports',
  telerikReportDesignerUrl: 'https://reporting-dev.aladdinportal.com/reportDesigner.html',

  // Hangfire
  hangfireDashboardUrl: 'https://api-dev.aladdinportal.com/queue',

  appInsights: {
    instrumentationKey: '0f10abe8-93d3-462f-a4c7-1d98d819c53e'
  },

  // Azure AD
  // MsalGuard is dropped so the E2E service identities can navigate on a seeded app JWT
  disableAdAuthentication: true,
  azureAdClientId: "b7ca3c52-577f-4bdb-a911-fa48dd5644ca",
  azureAdTenantId: "1d7e4b84-0706-4c90-ac14-6d1dc81c23db",
  azureAdRedirectUrl: "https://dev.aladdinportal.com",

  // deprecated
  reportServerUrl: 'https://aladdin.centralus.cloudapp.azure.com/reports/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts